<template>
    <div class="nav-right-button  position-relative d-flex">
        <div class="position-relative" :class="visibleSignupSignIn == false ? 'perspective-800' : ''">
            <el-button type="default" class="small-square mr-2" @click="isButtonsShow=!isButtonsShow">
                <el-icon>
                    <User />
                </el-icon>
            </el-button>

            <div :class="isButtonsShow ? 'active usersignin-and-signout-btns' : 'usersignin-and-signout-btns'">
                <el-button type="default" class="btn theme-btn theme-btn-outline mr-2" @click="visibleSignupSignIn = true">Login</el-button>
                <el-button type="default" class="btn theme-btn m-0" @click="visibleSignupSignIn = true">SignUp</el-button>
            </div>
        </div>



        <el-dropdown trigger="click" :max-height="400">
            <span class="el-dropdown-link user-inbox-btn small-square mr-2 position-relative">
                <el-icon><Box /></el-icon>
                <span class="notification-count position-absolute">3</span>
            </span>
            <template #dropdown>
                <el-dropdown-menu class="user-inbox-wrap" placement="top-start">
                    <div class="inbox-head">
                        Inbox
                    </div>
                    <el-dropdown-item>
                        <a href="#">
                            <span class="user-inbox-item-date">
                                <span class="user-inbox-type">Comment</span>
                                <span class="user-inbox-created">Mar 4 at 20:49</span>
                            </span>
                            <span class="title">How to make a flipbox responsive using html in column block</span>
                            <p class="inbox-summary">
                                Unfortunately, that didn't work on my site.  I would love an example of three boxes that flip...
                            </p>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#">
                            <span class="user-inbox-item-date">
                                <span class="user-inbox-type">Comment</span>
                                <span class="user-inbox-created">Mar 4 at 20:49</span>
                            </span>
                            <span class="title">How to make a flipbox responsive using html in column block</span>
                            <p class="inbox-summary">
                                Unfortunately, that didn't work on my site.  I would love an example of three boxes that flip...
                            </p>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#">
                            <span class="user-inbox-item-date">
                                <span class="user-inbox-type">election</span>
                                <span class="user-inbox-created">Oct 18, 2021 at 20:00</span>
                            </span>
                            <span class="title">How to make a flipbox responsive using html in column block</span>
                            <p class="inbox-summary">
                                Please cast your vote in the Stack Overflow 2021 community moderator election.
                            </p>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#">
                            <span class="user-inbox-item-date">
                                <span class="user-inbox-type">Comment</span>
                                <span class="user-inbox-created">Mar 4 at 20:49</span>
                            </span>
                            <span class="title">How to make a flipbox responsive using html in column block</span>
                            <p class="inbox-summary">
                                Unfortunately, that didn't work on my site.  I would love an example of three boxes that flip...
                            </p>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#">
                            <span class="user-inbox-item-date">
                                <span class="user-inbox-type">Comment</span>
                                <span class="user-inbox-created">Mar 4 at 20:49</span>
                            </span>
                            <span class="title">How to make a flipbox responsive using html in column block</span>
                            <p class="inbox-summary">
                                Unfortunately, that didn't work on my site.  I would love an example of three boxes that flip...
                            </p>
                        </a>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>


        <el-dropdown trigger="click" :max-height="400">
            <span class="el-dropdown-link user-inbox-btn small-square position-relative">
                <el-icon><Trophy /></el-icon>
                <span class="notification-count position-absolute">2</span>
            </span>
            <template #dropdown>
                <el-dropdown-menu class="user-inbox-wrap user-achivement-wrap" placement="top-start">
                    <div class="inbox-head d-flex align-center justify-content-between">
                        <div class="achivement-left">
                            Achievements <span class="time">UTC TIME 05:12</span>
                        </div>
                        <div class="achivement-links d-flex align-center">
                            <a href="#">privileges</a>
                            <span>.</span>
                            <a href="#">badges</a>
                        </div>
                    </div>
                    <el-dropdown-item>
                        <a href="#" class="d-flex">
                            <span class="rep-change rep-up">+10</span>
                            <span class="title">Why is the text blue at and after the form tags?</span>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#" class="d-flex">
                            <span class="rep-change rep-up">+49</span>
                            <span class="title">Dropdown menu won't appear in elementor Wordpress</span>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#" class="d-flex">
                            <span class="rep-change position-relative">
                                <span class="type-badge badge-silver"></span>
                            </span>
                            <span class="title">
                                You've earned the "Constituent" badge (Vote for a candidate in the final phase of an election).
                            </span>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#" class="d-flex">
                            <span class="rep-change position-relative">
                                <span class="type-badge badge-bronze"></span>
                            </span>
                            <span class="title">
                                You've earned the "Caucus" badge (Visit an election during any phase of an active election and have enough reputation to cast a vote).
                            </span>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#" class="d-flex">
                            <span class="rep-change rep-down">-1</span>
                            <span class="title">Required parameter $xxx follows optional parameter $yyy</span>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#" class="d-flex">
                            <span class="rep-change rep-up">+20</span>
                            <span class="title">Image resizing distorted in Safari on iOS</span>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#" class="d-flex">
                            <span class="rep-change rep-up">+25</span>
                            <span class="title">How to add space between border line and object above the border [html]</span>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#" class="d-flex">
                            <span class="rep-change rep-up">+8</span>
                            <span class="title">Uncaught SyntaxError: Unexpected token '!'</span>
                        </a>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <a href="#" class="d-flex">
                            <span class="rep-change rep-down">-2</span>
                            <span class="title">font awesome icons showing as a blank square</span>
                        </a>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>

        <el-dialog v-model="visibleSignupSignIn" class="user-sign-in-up-modal" width="450px" title="SignUp/LogIn Form">
            <div class="user-sign-in-up-modal-wrapper">
                <el-tabs v-model="activeTab" class="demo-tabs" @tab-click="handleClick">
                    <el-tab-pane label="SignUp" name="sign-up">
                        <div class="user-login-form">
                            <h1>Welcome! create an account</h1>
                            <el-form v-model="signUpFormData" label-position="top">
                                <el-form-item label="Name">
                                    <el-input v-model="signUpFormData.name" size="large" placeholder="Your Name"></el-input>
                                </el-form-item>
                                <el-form-item label="Email">
                                    <el-input v-model="signUpFormData.email" type="email" size="large" placeholder="Your Email"></el-input>
                                </el-form-item>
                                <el-form-item label="Password">
                                    <el-input v-model="signUpFormData.password" type="password" size="large" placeholder="Enter Password"></el-input>
                                    <el-alert  type="info" show-icon :closable="false">
                                        <p>Your password must be at least 6 characters long and must contain letters, numbers and special characters. Cannot contain whitespace.</p>
                                    </el-alert>
                                </el-form-item>
                                <el-form-item>
                                    <el-checkbox v-model="privacyPolicyAgree" label="By signing up, you agree to our " size="large" />
                                    <router-link to="/privacy-policy">Privacy Policy.</router-link>
                                </el-form-item>
                                <el-form-item>
                                    <el-button class="btn theme-btn">Sign Up</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="Log In" name="login">
                        <div class="user-login-form">
                            <h1>Good to see you again!</h1>
                            <el-form v-model="loginFormData" label-position="top">
                                <el-form-item label="Email">
                                    <el-input v-model="loginFormData.email" type="email" size="large"></el-input>
                                </el-form-item>
                                <el-form-item label="Password">
                                    <el-input v-model="loginFormData.password" type="password" size="large"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <div class="d-flex align-center justify-content-between w-full">
                                        <el-checkbox v-model="isRemember" label="Remember Me" size="large" />
                                        <a href="#">Forgot Password?</a>
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <el-button class="btn theme-btn">Login</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {User, Box, Trophy} from '@element-plus/icons-vue'

export default {
    components: {
        User,
        Box,
        Trophy,
    },
    data() {
        return {
            privacyPolicyAgree: false,
            isButtonsShow: false,
            isRemember: false,
            visibleSignupSignIn: false,
            activeTab: 'sign-up',
            signUpFormData: {
                name: '',
                email: '',
                password: ''
            },
            loginFormData: {
                email: '',
                password: ''
            }
        }
    }
}
</script>
<style scoped>

</style>